export default "__VITE_ASSET__DLRNpW21__"